<script setup>
defineProps({
  unknown: {
    type: Number,
    required: true
  },
  knownColor: {
    type: String,
    default: '#4CAF50'
  },
  unknownColor: {
    type: String,
    default: '#7484c4'
  }
});

</script>

<template>
  <div class="container">
    <div class="word-ratio-bar">
      <div class="known-words"
           :style="{
             width: (100 - unknown) + '%',
             backgroundColor: knownColor
           }">
      </div>
      <div class="unknown-words"
           :style="{
             width: unknown + '%',
             backgroundColor: unknownColor
           }">
      </div>
    </div>
    <div class="info">
      {{ 100 - unknown }}% znanego słownictwa
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px;
}

.word-ratio-bar {
  display: flex;
  flex-grow: 1;
  border-radius: 3px;
  overflow: hidden;
}

.known-words,
.unknown-words {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 8px;
}

.info {
  text-align: right;
  font-style: italic;
  color: #666666;
}

</style>
